import React from "react";
export var LeftPortionIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("svg", { viewBox: "0 0 20 20", className: ["item-customization-portion-icon", className].filter(Boolean).join(" "), "aria-hidden": "true", focusable: "false" },
        React.createElement("path", { d: "M10 2a8 8 0 1 0 0 16Z", fill: "currentColor" }),
        React.createElement("circle", { cx: "10", cy: "10", r: "8", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeOpacity: "0.65" })));
};
export var WholePortionIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("svg", { viewBox: "0 0 20 20", className: ["item-customization-portion-icon", className].filter(Boolean).join(" "), "aria-hidden": "true", focusable: "false" },
        React.createElement("circle", { cx: "10", cy: "10", r: "8", fill: "currentColor" })));
};
export var RightPortionIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("svg", { viewBox: "0 0 20 20", className: ["item-customization-portion-icon", className].filter(Boolean).join(" "), "aria-hidden": "true", focusable: "false" },
        React.createElement("path", { d: "M10 2a8 8 0 1 1 0 16Z", fill: "currentColor" }),
        React.createElement("circle", { cx: "10", cy: "10", r: "8", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeOpacity: "0.65" })));
};
